import { styled } from 'stitches.config'

export const InfluencerReviewRoot = styled('div', {
  color: '$primary-800',
})

export const ReviewImage = styled('div', {
  margin: 'auto',
  size: '180px',
  borderRadius: '$round',
  overflow: 'hidden',
})
